import React from 'react';
import PropTypes from 'prop-types';
import { degreeTitles } from './const';
import { default as countryList } from './countryList.json';
import './style.scss';

export default function Education({ education }) {
    const {
        degree_title,
        degree,
        school,
        to_year,
        country_code
    } = education;

    const country = countryList.find((country) => country.code === country_code.toLowerCase()).value;

    return (
        <li>
            <p>{degreeTitles[degree_title]} - {degree}</p>
            <p>{school}, {country}, {i18n.t('seller_profile.graduated')} {to_year}</p>
        </li>
    );
}

Education.propTypes = {
    education: PropTypes.shape({
        degree_title: PropTypes.number,
        degree: PropTypes.string,
        school: PropTypes.string,
        to_year: PropTypes.number
    })
};

Education.defaultProps = {
    education: {
        degree_title: 0,
        degree: '',
        school: '',
        to_year: 0
    }
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/EducationList/Education.js